import { buildCategoryPageLink, buildSubcategoryPageLink } from '@utils/link';
import { ReactElement } from 'react';
import { PageLink } from '../PageLink';
import { Container, Link, Separator } from './Breadcrumb.styles';
import { BreadcrumbProps } from './Breadcrumb.types';

export const Breadcrumb = ({
  category,
  subcategory,
  breadcrumbSize = '',
}: BreadcrumbProps): ReactElement => {
  if (!category) {
    return null;
  }

  return (
    <Container>
      <PageLink href={buildCategoryPageLink(category.slug)}>
        <Link style={breadcrumbSize ? { fontSize: breadcrumbSize } : undefined}>
          {category.name}
        </Link>
      </PageLink>
      {subcategory && (
        <>
          {' '}
          <Separator> &#47; </Separator>
          <PageLink href={buildSubcategoryPageLink(category.slug, subcategory.slug)}>
            <Link style={breadcrumbSize ? { fontSize: breadcrumbSize } : undefined}>
              {subcategory.name}
            </Link>
          </PageLink>
        </>
      )}
    </Container>
  );
};
